"use strict";
exports.__esModule = true;
exports.rewrite = void 0;
function rewrite(map, retrieve) {
    return function (uri) {
        var mappedURI = uri;
        for (var source in map) {
            if (uri.startsWith(source)) {
                mappedURI = uri.replaceAll(source, map[source]);
                break;
            }
        }
        return retrieve(mappedURI);
    };
}
exports.rewrite = rewrite;
